import { Injectable } from '@angular/core';
import { SeatingDetailService } from './seating-detail.service';

@Injectable({ providedIn: 'root' })
export class SeatingDetailResolver {
  constructor(private seatingDetailservice: SeatingDetailService) {}

  resolve() {
    return this.seatingDetailservice.fetchSeatingDetails();
  }
}
